<template>
  <Modal
    :id="'cmp-royalty-contracts-sidewindow-add_tracks'"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $dft.snakeCaseToWords("tracks") }}</template>

    <template slot="body">
      <div class="body-container">
        <SearchList
          :id="'tracks'"
          :items="items"
          :keyProperty="'track_id'"
          :label="'track_name'"
          :placeholder="'Search Tracks'"
          @selected="onTracksSelected"
          @searched="onTrackSearched"
        />
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import SearchList from "@dtplugins/search-list/search-list";
import { Subject } from "rxjs";
import { ContractsService } from "../../services/contracts.service";

export default {
  components: {
    Modal,
    SearchList
  },
  data() {
    return {
      unrelatedTracks: [],
      searchString: "",
      trackSearchString: "",
      searchSubject: new Subject(),
      selectedTracks: new Set()
    };
  },
  mounted: async function() {
    const res = await ContractsService.newTracks(this.contract_id);
    this.unrelatedTracks = res.data.tracks;
  },
  computed: {
    contract_id: function() {
      return this.$route.params.contract_id;
    },
    items: function() {
      return this.unrelatedTracks || [];
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onOkClick: async function() {
      const track_ids = Array.from(this.selectedTracks).join(","); // Convert to Array,  Join -- convert to string

      const res = await ContractsService.saveTracks({
        contract_id: this.contract_id,
        track_ids
      });

      this.$emit("added", res.data);
    },
    onSearchInputKeyup: function(e) {
      this.trackSearchString = e.target.value;
      this.searchSubject.next(this.trackSearchString);
    },

    onTrackSearched: async function(searchString) {
      this.trackSearchString = searchString;
      const res = await ContractsService.searchUnrelatedTracks({
        contract_id: this.contract_id,
        search: searchString
      });
      this.unrelatedTracks = res.data.tracks;
    },

    onTracksSelected: function(selectedTracks) {
      this.selectedTracks = selectedTracks;
    }
  }
};
</script>
